import strings from "./AiScoringSummary.strings";
import { useStrings } from "features/i18n/useStrings";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "app/hooks";
import { selectTotalAiScoringConfiguredQuestions } from "features/qualityForm/qualityFormSlice";
import {
    EvaluationSidePanelSummary,
    EvaluationSidePanelSummaryProps,
} from "components/EvaluationSidePanelSummary";
import { selectIsAIScoringQuestionCountValid } from "features/qualityForm/qualityFormValidations";
import { selectMaxPermissibleQuestionsWithAiScoring } from "features/qualityForm/qualityFormSlices";

export function AiScoringSummary() {
    const t = useStrings(strings);

    const { totalQuestions, totalQuestionsConfigured } = useAppSelector(
        (state) => {
            const totalQuestions = Object.keys(
                state.qualityForm.data.questions ?? {}
            ).length;

            const totalQuestionsConfigured =
                selectTotalAiScoringConfiguredQuestions(state);

            return {
                totalQuestions,
                totalQuestionsConfigured,
            };
        },
        shallowEqual
    );

    const tooManyAIScoringQuestions = useAppSelector(
        (state) => !selectIsAIScoringQuestionCountValid(state)
    );

    const maxAIScoringQuestions = useAppSelector(
        selectMaxPermissibleQuestionsWithAiScoring
    );

    const evaluationSidePanelSummaryProps: EvaluationSidePanelSummaryProps = {
        iconName: "aiScoring",
        assistanceIcon: t.labels.assistanceIcon,
        heading: t.labels.heading,
        preview: true,
        summary: t.summary({
            questionsConfiguredWithAiScoring: totalQuestionsConfigured,
            totalQuestionCount: totalQuestions,
            entity:
                totalQuestions === 1 ? t.labels.question : t.labels.questions,
            maxPermissibleQuestionsWithAiScoring: maxAIScoringQuestions,
        }),
        hasError: tooManyAIScoringQuestions,
        errorMessage: t.labels.aiScoringMaxQuestionsExceeded({
            maxAIScoringQuestions: maxAIScoringQuestions,
        }),
    };
    return (
        <div data-testid="ai-scoring-summary">
            <EvaluationSidePanelSummary {...evaluationSidePanelSummaryProps} />
        </div>
    );
}
